import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import createLocation from 'utils/createLocation';
import groupBy from 'utils/groupBy';
import { canUserShare, hasPrivilege, isTeamManager } from 'utils/privileges';
import getUserId from 'utils/session/getUserId';
import config from 'utils/config';
import isMultiDomain from 'utils/isMultiDomain';
import { BASIC } from 'styles/spacingPresets';
import Box from 'components/Box';
import Button from 'components/Button';
import Flex from 'components/Flex';
import Hidden from 'components/Hidden';
import Hint from 'components/Hint';
import InlineList from 'components/InlineList';
import { Menu, MenuButton, MenuItem, MenuItemDivider, MenuList } from 'components/Menu';
import StickyBox from 'components/StickyBox';
import TooltipButton from 'components/TooltipButton';
import Text from 'components/Text';
import ShareContentModal from 'screens/ShareModal';
import { useUpdateMultipleAssets } from 'actions/assets';
import { useUpdateMultiplePlaylists } from 'actions/playlists';
import useBreakpoints from 'hooks/useBreakpoints';
import useModalQueryParam from 'hooks/useModalQueryParam';
import { wasContentItemDataChanged, getImplicitlySelectedItems, getSelectionCompletionState } from '../utils';
import { checkIsItemEditable, checkIsSelectionEditable } from '../utils/checkIsItemEditable';
import { checkIsSelectionShareable } from '../utils/checkIsSelectionShareable';
import useGetContentShareData from '../utils/useGetContentShareData';
import AssetViewer from 'screens/SimpleAssetViewer';
import SelectMenu from './SelectMenu';
import { SaveChangedContentModal } from './SaveChangedContentModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function ToolbarContent(_ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(Flex, _objectSpread(_objectSpread({}, otherProps), {}, {
    align: "center",
    width: "100%",
    minHeight: 50,
    py: "xxs",
    children: children
  }));
}
export function Toolbar(_ref2) {
  var playlist = _ref2.playlist,
    selectedItems = _ref2.selectedItems,
    selectedItemIds = _ref2.selectedItemIds,
    reducerState = _ref2.reducerState,
    stickyHeaderCompensation = _ref2.stickyHeaderCompensation,
    clearSelection = _ref2.clearSelection,
    setSelectedItemIds = _ref2.setSelectedItemIds,
    onRequestEdit = _ref2.onRequestEdit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useBreakpoints = useBreakpoints('xs'),
    isDesktop = _useBreakpoints.xs;
  var location = useLocation();
  var history = useHistory();
  var userId = getUserId();
  var isPlaylistDistributed = isMultiDomain(playlist);
  var canAddOrMoveContent = !isPlaylistDistributed;
  var _useModalQueryParam = useModalQueryParam('share-selection'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasShareModal = _useModalQueryParam2[0],
    toggleShareModal = _useModalQueryParam2[1];
  var hasCircularReferenceSelected = selectedItems.some(function (item) {
    return item.type === 'playlist' && item.wouldCauseCircularReference === true;
  });
  var checkCanRemoveAndSetOptional = useMemo(function () {
    return canAddOrMoveContent && (hasPrivilege('playlist_write') || playlist.ownerTeamId && isTeamManager(playlist.ownerTeamId) || playlist.allow_member_contributions && config.memberContributions && selectedItems.every(function (item) {
      var _item$author;
      return item.type !== 'section' && item.type !== 'playlist' && ((_item$author = item.author) === null || _item$author === void 0 ? void 0 : _item$author.id) === userId;
    }));
  }, [playlist.allow_member_contributions, playlist.ownerTeamId, canAddOrMoveContent, selectedItems, userId]);
  var _reducerState = _slicedToArray(reducerState, 2),
    _reducerState$ = _reducerState[0],
    content = _reducerState$.content,
    contentPendingDeletion = _reducerState$.contentPendingDeletion,
    mobileInteractionMode = _reducerState$.mobileInteractionMode,
    dispatch = _reducerState[1];
  var _useUpdateMultipleAss = useUpdateMultipleAssets({
      assets: contentPendingDeletion || []
    }),
    updateMultipleAssets = _useUpdateMultipleAss.updateMultipleAssets,
    isUpdatingMultipleAsset = _useUpdateMultipleAss.isPending;
  var _useUpdateMultiplePla = useUpdateMultiplePlaylists({}),
    updateMultiplePlaylists = _useUpdateMultiplePla.updateMultiplePlaylists,
    isUpdatingMultiplePlaylists = _useUpdateMultiplePla.isPending;

  // These are all items that are selected, but including all content items
  // inside of selected sections, and excluding the selected sections themselves
  var implicitlySelectedItems = useMemo(function () {
    return getImplicitlySelectedItems({
      selectedItemIds: selectedItemIds,
      content: content
    });
  }, [content, selectedItemIds]);
  function deleteSelectedItems() {
    var hasUnsavedChanges = implicitlySelectedItems.some(function (item) {
      return wasContentItemDataChanged(item);
    });
    if (hasUnsavedChanges) {
      dispatch({
        type: 'REQUEST_DELETE_CHANGED_CONTENT',
        ids: selectedItemIds
      });
    } else {
      dispatch({
        type: 'DELETE_CONTENT',
        ids: selectedItemIds
      });
      clearSelection();
    }
  }
  function confirmDeleteChangedContent(_x) {
    return _confirmDeleteChangedContent.apply(this, arguments);
  } // Completion state of the selected items
  function _confirmDeleteChangedContent() {
    _confirmDeleteChangedContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(ids) {
      var _groupBy, assets, playlists;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (contentPendingDeletion) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            _groupBy = groupBy(contentPendingDeletion, function (item) {
              if (item.type === 'playlist') {
                return 'playlists';
              }
              return 'assets';
            }), assets = _groupBy.assets, playlists = _groupBy.playlists;
            _context.next = 2;
            return Promise.all([assets && updateMultipleAssets(assets), playlists && updateMultiplePlaylists(playlists)]);
          case 2:
            dispatch({
              type: 'DELETE_CONTENT',
              ids: ids
            });
            clearSelection();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _confirmDeleteChangedContent.apply(this, arguments);
  }
  var selectionCompletionState = useMemo(function () {
    return getSelectionCompletionState(implicitlySelectedItems);
  }, [implicitlySelectedItems]);
  function makeSelectedItemsRequired() {
    dispatch({
      type: 'UPDATE_CONTENT',
      data: implicitlySelectedItems.map(function (item) {
        return {
          id: item.id,
          optional: false
        };
      })
    });
  }
  function makeSelectedItemsOptional() {
    dispatch({
      type: 'UPDATE_CONTENT',
      data: implicitlySelectedItems.map(function (item) {
        return {
          id: item.id,
          optional: true
        };
      })
    });
  }
  function setSelection(value) {
    if (value === 'all') {
      var allContentIds = content.map(function (item) {
        return item.id;
      });
      setSelectedItemIds(allContentIds);
    }
    if (value === 'assets') {
      var allAssetIds = content.filter(function (content) {
        return content.type !== 'playlist' && content.type !== 'section';
      }).map(function (item) {
        return item.id;
      });
      setSelectedItemIds(allAssetIds);
    }
    if (value === 'playlists') {
      var allPlaylistIds = content.filter(function (content) {
        return content.type === 'playlist';
      }).map(function (item) {
        return item.id;
      });
      setSelectedItemIds(allPlaylistIds);
    }
  }
  function openSingleSelectedAsset() {
    history.push(createLocation(location, {
      assetId: selectedItemIds[0]
    }));
  }
  function checkIsAsset(items) {
    return items.some(function (item) {
      return item.type !== 'playlist' && item.type !== 'section';
    });
  }
  var hasOptionalButton = checkCanRemoveAndSetOptional && (selectionCompletionState === 'required' || selectionCompletionState === 'mixed');
  var hasRequiredButton = checkCanRemoveAndSetOptional && (selectionCompletionState === 'optional' || selectionCompletionState === 'mixed');
  var hasEditAssetsButton = selectedItems.length > 1;
  var isEditAssetsButtonEnabled = useMemo(function () {
    return selectedItems.length > 1 && checkIsSelectionEditable({
      items: selectedItems,
      parentPlaylistMemberContributions: playlist.allow_member_contributions
    });
  }, [selectedItems, playlist.allow_member_contributions]);
  var isShareButtonEnabled = useMemo(function () {
    return checkIsSelectionShareable({
      items: selectedItems
    });
  }, [selectedItems]);
  var hasEditButton = useMemo(function () {
    return selectedItems.length === 1 && checkIsItemEditable({
      item: selectedItems[0],
      isParentPlaylistDistributed: isPlaylistDistributed,
      parentPlaylistMemberContributions: playlist.allow_member_contributions,
      parentPlaylistOwnerTeamId: playlist.ownerTeamId
    });
  }, [selectedItems, isPlaylistDistributed, playlist.allow_member_contributions, playlist.ownerTeamId]);
  var hasSelectedItems = selectedItemIds.length > 0;
  var hasMultipleSelectedItems = selectedItemIds.length > 1;
  var shareData = useGetContentShareData({
    items: selectedItems,
    parentPlaylistId: playlist.id
  });
  var hasSingleAssetSelected = selectedItemIds.length === 1 && checkIsAsset(selectedItems);
  var primaryActions = [!isDesktop && canAddOrMoveContent && {
    label: t('actions_move'),
    icon: 'move-vertical',
    onClick: function onClick() {
      return dispatch({
        type: 'SET_MOBILE_INTERACTION_MODE',
        mode: 'move'
      });
    }
  }, hasOptionalButton && {
    label: t('actions_make_optional'),
    icon: 'skip',
    onClick: makeSelectedItemsOptional
  }, hasRequiredButton && {
    label: t('actions_make_required'),
    icon: 'bang',
    title: hasCircularReferenceSelected ? t('optional_content_hint_circular_reference_multiselected') : undefined,
    isDisabled: hasCircularReferenceSelected,
    onClick: makeSelectedItemsRequired
  }, hasEditButton && {
    label: t('actions_edit'),
    icon: 'edit',
    onClick: function onClick() {
      return onRequestEdit([selectedItemIds[0]]);
    }
  }, hasEditAssetsButton && {
    title: isEditAssetsButtonEnabled ? undefined : t('hint_multi_editing_only_for_assets'),
    isDisabled: !isEditAssetsButtonEnabled,
    label: t('actions_edit_selection'),
    icon: 'edit',
    onClick: function onClick() {
      return onRequestEdit(selectedItemIds);
    }
  }].filter(function (action) {
    return !!action;
  });
  var deleteAction = checkCanRemoveAndSetOptional ? {
    label: t('actions_remove'),
    icon: 'trash',
    onClick: deleteSelectedItems
  } : null;
  var openAction = hasSingleAssetSelected ? {
    label: t('actions_open'),
    icon: 'eye-open',
    onClick: openSingleSelectedAsset
  } : null;
  var shareAction = canUserShare() ? {
    isDisabled: !isShareButtonEnabled,
    title: isShareButtonEnabled ? undefined : t('hint_multi_sharing_only_for_assets_or_playlists'),
    label: t(hasMultipleSelectedItems ? 'actions_share_selection' : 'actions_share'),
    icon: 'send',
    onClick: toggleShareModal
  } : null;
  var hasMenuActions = primaryActions.length > 0 || deleteAction !== null;
  var hasContent = content.length > 0;
  var hasAssets = checkIsAsset(content);
  var hasPlaylists = content.some(function (item) {
    return item.type === 'playlist';
  });
  var defaultToolbarHint = t('content_editor_select_to_move_or_edit');
  if (!canAddOrMoveContent) {
    defaultToolbarHint = t('immutability_note_distributed_playlist_content');
  }
  if (!hasContent) {
    defaultToolbarHint = t('empty_playlist');
  }
  var NoSelectionContent = hasContent ? /*#__PURE__*/_jsxs(InlineList, {
    splitBy: "dot",
    align: "middle",
    children: [/*#__PURE__*/_jsx(Text, {
      children: defaultToolbarHint
    }), /*#__PURE__*/_jsx(SelectMenu, {
      onSelect: setSelection,
      hasAssets: hasAssets,
      hasPlaylists: hasPlaylists
    })]
  }) : defaultToolbarHint;
  var clearSelectionButton = /*#__PURE__*/_jsx(TooltipButton, {
    iconOnly: true,
    icon: "x",
    variant: "transparent",
    size: "medium",
    title: t('actions_deselect_all'),
    onClick: clearSelection,
    ml: "-xs",
    mr: [undefined, 'xs'],
    breakpoints: "s",
    children: t('actions_deselect_all')
  });
  var toolbarContent = isDesktop ? /*#__PURE__*/_jsxs(ToolbarContent, {
    wrap: true,
    rowGap: "xxs",
    px: "m",
    children: [hasSelectedItems && clearSelectionButton, /*#__PURE__*/_jsx(Box, {
      shrink: true,
      pr: "m",
      children: hasSelectedItems ? t('generic_selection_status_short', {
        count: selectedItemIds.length
      }) : NoSelectionContent
    }), hasSelectedItems && /*#__PURE__*/_jsx(Box, {
      shrink: true,
      children: /*#__PURE__*/_jsxs(InlineList, {
        spacing: "xs",
        children: [primaryActions.map(function (action) {
          return /*#__PURE__*/_jsx(TooltipButton, {
            variant: "primary",
            size: "medium",
            onClick: action.onClick,
            isDisabled: action.isDisabled,
            title: action.title,
            children: action.label
          }, action.label);
        }), openAction && /*#__PURE__*/_jsx(TooltipButton, {
          iconOnly: true,
          icon: openAction.icon,
          variant: "primary",
          size: "medium",
          onClick: openAction.onClick,
          children: openAction.label
        }), shareAction && /*#__PURE__*/_jsx(TooltipButton, {
          iconOnly: true,
          icon: shareAction.icon,
          variant: "primary",
          size: "medium",
          onClick: shareAction.onClick,
          isDisabled: shareAction.isDisabled,
          title: shareAction.title,
          children: shareAction.label
        }), deleteAction && /*#__PURE__*/_jsx(TooltipButton, {
          iconOnly: true,
          icon: deleteAction.icon,
          variant: "primary",
          size: "medium",
          onClick: deleteAction.onClick,
          children: deleteAction.label
        })]
      })
    }), hasSelectedItems && canAddOrMoveContent && /*#__PURE__*/_jsx(Hidden, {
      below: "m",
      shrink: true,
      ml: "auto",
      children: /*#__PURE__*/_jsx(Hint, {
        iconSpacing: "xxs",
        iconOffset: "-xxxs",
        children: t('content_editor_move_hint')
      })
    })]
  }) : mobileInteractionMode === 'move' ? /*#__PURE__*/_jsxs(ToolbarContent, {
    gap: "m",
    px: "s",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: true,
      shrink: true,
      children: hasSelectedItems ? t('content_editor_move_hint') : t('content_editor_select_to_move')
    }), /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        size: "medium",
        onClick: function onClick() {
          return dispatch({
            type: 'SET_MOBILE_INTERACTION_MODE',
            mode: 'default'
          });
        },
        children: t('actions_done')
      })
    })]
  }) : /*#__PURE__*/_jsxs(ToolbarContent, {
    px: "s",
    children: [hasSelectedItems && clearSelectionButton, /*#__PURE__*/_jsx(Box, {
      shrink: true,
      pr: "m",
      mr: "auto",
      children: hasSelectedItems ? t('generic_selection_status_short', {
        count: selectedItemIds.length
      }) : NoSelectionContent
    }), hasSelectedItems && hasMenuActions && /*#__PURE__*/_jsx(Box, {
      shrink: true,
      children: /*#__PURE__*/_jsxs(Menu, {
        menuPlacement: "bottom-end",
        children: [/*#__PURE__*/_jsx(MenuButton, {
          variant: "primary",
          size: "medium",
          iconRight: "chevron",
          children: t('actions')
        }), /*#__PURE__*/_jsxs(MenuList, {
          children: [primaryActions.map(function (action) {
            return /*#__PURE__*/_jsx(MenuItem, {
              onClick: action.onClick,
              icon: action.icon,
              isDisabled: action.isDisabled,
              children: action.label
            }, action.label);
          }), (shareAction || openAction) && /*#__PURE__*/_jsx(MenuItemDivider, {}), openAction && /*#__PURE__*/_jsx(MenuItem, {
            icon: openAction.icon,
            onClick: openAction.onClick,
            children: openAction.label
          }), shareAction && /*#__PURE__*/_jsx(MenuItem, {
            onClick: shareAction.onClick,
            icon: shareAction.icon,
            isDisabled: shareAction.isDisabled,
            children: shareAction.label
          }), deleteAction && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(MenuItemDivider, {}), /*#__PURE__*/_jsx(MenuItem, {
              onClick: deleteAction.onClick,
              icon: deleteAction.icon,
              children: deleteAction.label
            })]
          })]
        })]
      })
    })]
  });
  return /*#__PURE__*/_jsxs(StickyBox, {
    placement: "top",
    distance: stickyHeaderCompensation
    // Ensure the toolbar doesn't cover up
    // popovers inside of EditorPageHeader
    ,
    zIndexOffset: -1,
    backgroundColor: "shaded",
    mx: ['-s', 0],
    borderRadius: [undefined, 'small'],
    fontSize: BASIC.SMALL,
    breakpoints: BASIC.BREAKPOINTS,
    children: [toolbarContent, contentPendingDeletion && (contentPendingDeletion === null || contentPendingDeletion === void 0 ? void 0 : contentPendingDeletion.length) > 0 && /*#__PURE__*/_jsx(SaveChangedContentModal, {
      contentPendingDeletion: contentPendingDeletion,
      onConfirm: function onConfirm() {
        return confirmDeleteChangedContent(selectedItemIds);
      },
      onClose: function onClose() {
        return dispatch({
          type: 'CANCEL_REQUEST_DELETE_CHANGED_CONTENT',
          ids: selectedItemIds
        });
      },
      onDiscard: function onDiscard() {
        return dispatch({
          type: 'DELETE_CONTENT',
          ids: selectedItemIds
        });
      },
      isLoading: isUpdatingMultipleAsset || isUpdatingMultiplePlaylists
    }), hasShareModal && shareData && /*#__PURE__*/_jsx(ShareContentModal, {
      data: shareData,
      onClose: toggleShareModal
    }), /*#__PURE__*/_jsx(AssetViewer, {})]
  });
}